<!--
  @description Renders the Allez! Allez! SVG brand logo as a router-link to the home route.
  No props — logo asset and destination are fixed. Intended for use inside Navbar.

  @example
  <BrandLogo />

  @accessibility The wrapping anchor carries `aria-label="Home"` so screen readers announce the
  navigation intent rather than an empty link.
-->
<template>
  <div class="navbar__brand">
    <router-link :to="{ name: 'home' }" class="no-active" aria-label="Home">
      <img src="../../../assets/Logo-App.svg" alt="Logo Allez! Allez!" />
    </router-link>
  </div>
</template>

<style scoped lang="scss">
@import './Navbar.scss';
</style>
